import React from 'react';
import PropTypes from 'prop-types';
import { getColor } from "core/utils/Styles";

const TrashSVG = ({ fill, ...props }) => (
	<svg width="1em" height="1em" viewBox="0 0 18 18" {...props}>
		<g fill="none">
			<path d="M0 0h18v18H0z" />
			<path
				fill={fill}
				d="M2.25 6.75v9A2.257 2.257 0 004.5 18h9a2.257 2.257 0 002.25-2.25v-9H2.25zM13.5 3.375v-2.25C13.5.45 13.05 0 12.375 0h-6.75C4.95 0 4.5.45 4.5 1.125v2.25H0v2.25h18v-2.25h-4.5zm-2.25 0h-4.5V2.25h4.5v1.125z"
			/>
		</g>
	</svg>
);

TrashSVG.propTypes = {
	fill: PropTypes.string,
};

TrashSVG.defaultProps = {
	fill: getColor('dustyGray'),
};

export default TrashSVG;
